import React, { useEffect, useState } from 'react';
import { useFilePicker } from 'use-file-picker';
import Camera, { IMAGE_TYPES, FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import Modal from 'react-modal';
import galleryIcon from '../../static/icons/gallery.png';
import switchIcon from '../../static/icons/switch.png';

const ImagePicker = (props) => {
  const [overlay, setOverlay] = useState(false);
  const [switched, setSwitch] = useState(false);
  const [image, setImage] = useState(null);
  const [openFileSelector, { filesContent }] = useFilePicker({ accept: 'image/*', multiple: false, readAs: 'DataURL' });

  useEffect(() => {
    if (filesContent.length) {
      const image = filesContent[0].content;
      setImage(image);
      setOverlay(false);
    }
  }, [filesContent]);

  useEffect(() => {
    setTimeout(() => {
      console.log(window.innerHeight);
      let elements = document.getElementsByClassName('react-html5-camera-photo-fullscreen');
      if (elements.length && isIosDevice()) {
        let childCount = elements.item(0).children.length;
        for (let i = 0; i < childCount; i++) {
          let child = elements.item(0).children.item(i);
          if (child.nodeName === 'VIDEO') {
            if (window.innerHeight < 600) {
              child.setAttribute('style', 'height:80vh !important; transform: rotateY(180deg); display: inline-block;');
            } else {
              child.setAttribute('style', 'height:90vh !important; transform: rotateY(180deg); display: inline-block;');
            }
          }
        }
      }
    }, 500);
  }, [overlay]);

  useEffect(() => {
    if (image) {
      let event = { target: { name: props.inputName, value: image } };
      props.onChange(event);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  const isIosDevice = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return true;
    }
    return false;
  };

  const openCamera = () => {
    setOverlay(!overlay);
  };
  const handleTakePhoto = (dataUri) => {
    setImage(dataUri);
  };

  const handleCameraError = (error) => {
    console.log(error);
    setOverlay(false);
    openFileSelector();
  };

  return (
    <div>
      <div style={{ width: 'fit-content' }} onClick={() => openCamera()}>
        {props.children}
      </div>
      <div className="imageCont mt-2">{image && <img className="object-center" width={400} height={200} src={image} alt="userImage" />}</div>
      <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="Overlay"
        onRequestClose={() => {
          setOverlay(false);
        }}
        isOpen={overlay}
      >
        <div className="cameraContainer">
          {switched ? (
            <Camera
              idealFacingMode={FACING_MODES.ENVIRONMENT}
              idealResolution={{ width: 640, height: 480 }}
              isImageMirror={false}
              imageType={IMAGE_TYPES.JPG}
              isFullscreen={true}
              onTakePhoto={(dataUri) => {
                handleTakePhoto(dataUri);
              }}
              onCameraError={(error) => {
                handleCameraError(error);
              }}
              isDisplayStartCameraError={false}
              onTakePhotoAnimationDone={() => {
                setOverlay(false);
              }}
            />
          ) : (
            <Camera
              idealFacingMode={FACING_MODES.USER}
              idealResolution={{ width: 640, height: 480 }}
              isImageMirror={true}
              imageType={IMAGE_TYPES.JPG}
              isFullscreen={true}
              onTakePhoto={(dataUri) => {
                handleTakePhoto(dataUri);
              }}
              onCameraError={(error) => {
                handleCameraError(error);
              }}
              isDisplayStartCameraError={false}
              onTakePhotoAnimationDone={() => {
                setOverlay(false);
              }}
            />
          )}
          <div className="switchCamera">
            <img
              className="ml-4 object-center"
              width={40}
              src={galleryIcon}
              alt="gallery"
              onClick={() => {
                openFileSelector();
              }}
            />
            <img
              className="mr-4 object-center"
              width={40}
              onClick={() => {
                setSwitch(!switched);
              }}
              src={switchIcon}
              alt="switch"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ImagePicker;
